export const mirroringArrayField = 'mirroring-array-field';
export const mirroringWorkstreamField = 'mirroring-workstream-field';
export const mirroringColumnField = 'mirroring-column-field';
